import React from "react";
import { useState, useRef } from "react";
import { Container, Col, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { Link, useHistory } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { JsonToTable } from "react-json-to-table";
import xls from "xlsx";
import { Modal } from "react-bootstrap";
import { uploadVPSTransaction } from "../../stores/services/transactions.service";

const TransactionUploader = () => {
  const history = useHistory();
  const distName: any = history.location?.state;

  const email = sessionStorage.getItem("email") || "";
  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState("");
  const [fileData, setfileData] = useState<any>([]);
  const [fileSomeData, setfileSomeData] = useState<any>([]);
  const [remainingCount, setRemainingCount] = useState("");
  const myRef1 = useRef<HTMLInputElement>(null);
  const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
  const [fileDataCount, setFileDataCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [excelFile, setExcelFile] = useState<any>();
  const [errorData, setErrorData] = useState<any>([]);
  const [errorBoolean, setErrorBoolean] = useState(false);

  const upload = async (e: any) => {
    setFileError("");
    // setExcelFile(e?.current?.files[0])

    let file = e?.target.files[0];
    setExcelFile(file);
    let type = file.name.substring(file.name.lastIndexOf(".") + 1);
    if (type === "xlsx" || type === "csv") {
      fileData.length = 0;
      setfileSomeData(fileData);
      setFile(file);
      setFileName(file.name);
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target?.result;
        const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data: any = xls.utils.sheet_to_json(ws, {
          header: 2,
          raw: false,
          defval: "",
          dateNF: "YYYY-MM-DD",
        });
        /* Update state */

        if (data) {
          if (data?.length == 0) {
            setfileData([]);
            setFileDataCount(0);
            setExcelFile("");
            toast.error("File should not be empty");
          }
          // if (!data?.every((ele) => ele?.["TXN Type"] === distName)) {
          //     toast.error("TXN Type should be same for all rows")
          //     setfileData([]);
          //     setFileDataCount(0)
          //     setExcelFile("")
          //     return
          // }
          setfileData(data);
          setFileDataCount(data.length);
        }
      };
      if (rABS) reader.readAsBinaryString(file);
      else reader.readAsArrayBuffer(file);
    } else {
      toast.error("Please Upload Correct Format of File");
    }
    // removing value so that user can upload same file again
    e.target.value = "";
  };

  const UploadVpsTransaction = async () => {
    try {
      let response = await uploadVPSTransaction(excelFile);
      if (response?.status === 200 && response?.data?.success === true) {
        toast.success("File uploaded Successfuly!");
        setfileData([]);
        setFileDataCount(0);
        setFileName("")
        setExcelFile("")
      } else if (
        response?.data?.data?.parsing_error_details?.length > 0 ||
        response?.data?.data?.save_error_details?.length > 0
      ) {
        toast.error("Kindly Resolve error first!");
        setErrorData(
          response?.data?.data?.parsing_error_details?.length > 0
            ? response?.data?.data?.parsing_error_details
            : response?.data?.data?.save_error_details
        );
        setErrorBoolean(true);
      }
    } catch (error) {
      setErrorBoolean(false);
      setErrorData([]);
    }
  };

  return (
    <>
      <div className="content">
        <Modal
          className=""
          dialogClassName="modal90w"
          show={errorBoolean}
          size="xl"
          backdrop={true}
          enforceFocus={false}
          onHide={() => {
            setErrorBoolean(false);
          }}
        >
          <div className="modal-header ">
            <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => {
                setErrorBoolean(false);
              }}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
            <h6 className="title title-up">
              Kindly fill following fields data Missing Fields
            </h6>
          </div>

          <div className="modal-body">
            <div className="col-12">
              <Row>
                <table className="table ">
                  <thead>
                    <th
                      style={{
                        padding: "12px 6px",
                        width: "10%",
                      }}
                    >
                      Row
                    </th>
                    <th
                      style={{
                        padding: "12px 6px",
                        width: "20%",
                      }}
                    >
                      Folio No
                    </th>
                    <th
                      style={{
                        padding: "12px 6px",
                        width: "70%",
                      }}
                    >
                      Error
                    </th>
                  </thead>
                  <tbody>
                    {errorData?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              maxWidth: "10%",
                            }}
                          >
                            {item?.row || "-"}
                          </td>
                          <td
                            style={{
                              maxWidth: "20%",
                            }}
                          >
                            {item?.folio_no}
                          </td>
                          <td
                            style={{
                              maxWidth: "70%",
                            }}
                            className="text-wrap"
                          >
                            {item?.error}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Row>
            </div>
          </div>
        </Modal>
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="card">
                <div className="d-flex align-items-center"></div>

                <div className="">
                  <div className="card-header">
                    <h4 className="card-title">
                      VPS Transaction Uploader
                      <a
                        className="float-right"
                        href="./../../Uploader-Sample/vps-transaction-sample.csv"
                        download
                      >
                        Download Sample
                      </a>
                    </h4>
                  </div>
                  <div className="card-body">
                    {" "}
                    <div className="row">
                      <div className="col-md-4">
                        <div onClick={() => myRef1?.current?.click()}>
                          <div className="form-group">
                            <div
                              className="form-control"
                              data-tip="Upload File"
                            >
                              {fileName === "" ? "Upload File" : fileName}
                            </div>
                            <input
                              type="file"
                              ref={myRef1}
                              style={{ display: "none" }}
                              multiple={false}
                              data-tip="Upload File"
                              onChange={(e) => {
                                upload(e);
                              }}
                              onClick={(e) => {
                                e.currentTarget.value = "";
                              }}
                            />
                            {fileError ? (
                              <p className="error-labels error-message2">
                                {fileError}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        {fileUploadingFlag && (
                          <i className="fa fa-spinner fa-spin fa-2x"></i>
                        )}
                      </div>
                    </div>
                    <div className="table-responsive">
                      <JsonToTable json={fileData} />
                    </div>
                    {remainingCount !== "" && (
                      <>
                        <span className="text-primary">
                          {"... " + remainingCount + " More Rows"}
                        </span>
                        <br />
                      </>
                    )}
                    Total Rows:{" "}
                    <span className="text-primary mt-3">{fileDataCount} </span>
                    <div className="">
                      <button
                        className="btn btn-info"
                        onClick={() => {
                          UploadVpsTransaction();
                        }}
                        disabled={Boolean(loading) || fileData?.length === 0}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Save</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TransactionUploader;
